// Typelizer digest 4d6f0104441c6f0b7b10d42075288f5e
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /api/v1/productions/:production_id/audio/:file */
  show: (
    params: { productionId: string | number; file: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/api/v1/productions/:production_id/audio/:file', params, options),
    method: 'get',
  }),
}
